import type { ButtonHTMLAttributes } from 'react';
import { focusableClassName } from '../../helpers/spatialFocus';

export const BackButton = (props: ButtonHTMLAttributes<HTMLButtonElement>) => (
  <button
    type="button"
    className={`back-button ${focusableClassName}`}
    data-focus-key="player:back"
    aria-label="Go back"
    {...props}
  >
    <svg aria-hidden="true" viewBox="0 0 448 512">
      <path
        fill="currentColor"
        d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H109.3L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"
      />
    </svg>
  </button>
);
